import React from 'react';
import ExpandedGreetingHeader from './ExpandedGreetingHeader';
import ChooseWorkflow from './ChooseWorkflow';
// import SearchWorkflows from './SearchWorkflows';
import '../../Widget';
import '../../../utils/Flows';
import { THEME } from '../../../../clearstep/util/Theme';
export var ExpandedState = function (_a) {
    var _b;
    var mobileState = _a.mobileState, setWorkflow = _a.setWorkflow, setWidgetState = _a.setWidgetState, workflows = _a.workflows, sessionId = _a.sessionId;
    return (React.createElement("div", { className: "relative flex h-full animate-widget-fade-in flex-col overflow-hidden rounded-md bg-white" },
        React.createElement(ExpandedGreetingHeader, { mobileState: mobileState, setWidgetState: setWidgetState, iconPath: (_b = THEME.widgetCustomizations) === null || _b === void 0 ? void 0 : _b.iconPath }),
        React.createElement("div", { className: "flex-grow overflow-y-auto px-4 pb-4" },
            React.createElement(ChooseWorkflow, { setWorkflow: setWorkflow, workflows: workflows === null || workflows === void 0 ? void 0 : workflows.filter(function (workflow) { return workflow.isVisible; }), sessionId: sessionId === null || sessionId === void 0 ? void 0 : sessionId.current }))));
};
export default ExpandedState;
